import Raven from 'raven-js';
import { markActionComplete } from 'user-context/onboarding';

// @ts-expect-error Untyped module
import { ContentTypes } from '../constants/base';
export const completeOnboardingPublishTask = contentType => {
  const actionName = 'explore-publish-site';
  return contentType === ContentTypes.SITE_PAGE ? markActionComplete(actionName, {
    showTaskCompletionModal: false
  }).catch(error => Raven.captureMessage(`Failed to check or complete onboarding task (${actionName}) `, {
    extra: {
      error
    }
  })) : Promise.resolve();
};